function waitForIceGathering(pc, timeoutMs = 5000) {
  if (pc.iceGatheringState === 'complete') return Promise.resolve();
  return new Promise((resolve) => {
    const timer = window.setTimeout(done, timeoutMs);
    function done() {
      window.clearTimeout(timer);
      pc.removeEventListener('icegatheringstatechange', check);
      resolve();
    }
    function check() {
      if (pc.iceGatheringState === 'complete') done();
    }
    pc.addEventListener('icegatheringstatechange', check);
  });
}

export async function createWhepViewer({ video, whepUrl, token, iceServers = [], onStateChange, onTrack, muted = true }) {
  if (!video) throw new Error('The Studio preview player is unavailable');
  if (!whepUrl || !token) throw new Error('Private OBS preview credentials are unavailable');

  const pc = new RTCPeerConnection({ iceServers });
  const remoteStream = new MediaStream();
  video.muted = muted;
  video.srcObject = remoteStream;
  pc.addTransceiver('video', { direction: 'recvonly' });
  pc.addTransceiver('audio', { direction: 'recvonly' });
  pc.addEventListener('track', (event) => {
    if (!remoteStream.getTracks().some((track) => track.id === event.track.id)) remoteStream.addTrack(event.track);
    onTrack?.(event.track, remoteStream);
    void video.play().catch(() => {});
  });
  pc.addEventListener('connectionstatechange', () => onStateChange?.(pc.connectionState));

  try {
    await pc.setLocalDescription(await pc.createOffer());
    await waitForIceGathering(pc);
    const response = await fetch(whepUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/sdp',
      },
      body: pc.localDescription.sdp,
    });
    if (!response.ok) throw new Error(`Private OBS preview failed (${response.status})`);
    await pc.setRemoteDescription({ type: 'answer', sdp: await response.text() });
    const location = response.headers.get('location');
    const resourceUrl = location ? new URL(location, whepUrl).toString() : '';
    void video.play().catch(() => {});
    return {
      pc,
      async close() {
        if (resourceUrl) {
          await fetch(resourceUrl, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
        }
        pc.close();
        remoteStream.getTracks().forEach((track) => track.stop());
        if (video.srcObject === remoteStream) video.srcObject = null;
      },
    };
  } catch (error) {
    pc.close();
    remoteStream.getTracks().forEach((track) => track.stop());
    if (video.srcObject === remoteStream) video.srcObject = null;
    throw error;
  }
}
